import { Input, Form, Spin } from 'antd'
import { useIntl } from 'react-intl'

const LdapAction: React.FC<{ formLoading?: boolean }> = ({ formLoading }) => {
  const { $t } = useIntl()

  return (
    <div>
      <Spin spinning={!!formLoading} fullscreen data-testid='spinner' />
      <div style={{ width: 320, margin: '0 auto' }}>
        <Form.Item 
          label={$t({ defaultMessage: 'User Name' })} 
          name='username'
          rules={[
            { required: true, message: $t({ defaultMessage: 'Please input your username!' }) },
            {
              pattern: /^.+$/,
              message: $t({ defaultMessage: 'Username cannot be empty' })
            }
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item 
          label={$t({ defaultMessage: 'Password' })} 
          name='password'
          rules={[
            { required: true, message: $t({ defaultMessage: 'Please input your password!' }) },
          ]}
        >
          <Input.Password />
        </Form.Item>
      </div>
    </div>
  )
}

export default LdapAction